import { DiagnosticChecklist } from "./diagnosticChecklistTypes.ts";

export interface DiagnosticChecklistStore {
  register: (checklist: DiagnosticChecklist) => void;
  unregister: (id: string) => void;
  subscribe: (listener: () => void) => () => void;
  getSnapshot: () => DiagnosticChecklist[];
}

export function createDiagnosticChecklistStore(): DiagnosticChecklistStore {
  const checklists = new Map<string, DiagnosticChecklist>();
  const listeners = new Set<() => void>();
  let snapshot: DiagnosticChecklist[] = [];

  const notify = () => {
    snapshot = Array.from(checklists.values());
    listeners.forEach((listener) => listener());
  };

  return {
    register: (checklist) => {
      checklists.set(checklist.id, checklist);
      notify();
    },
    unregister: (id) => {
      if (checklists.delete(id)) {
        notify();
      }
    },
    subscribe: (listener) => {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
    getSnapshot: () => snapshot,
  };
}

/**
 * One shared instance. A context is not necessary, because only one tree
 * reads the store. A registrar registers on each render. Thus a provider
 * that holds the data in state renders the full My Courses tree on each
 * write.
 */
export const diagnosticChecklistStore = createDiagnosticChecklistStore();
